import React, { useState, useEffect } from "react";
import TranslationService from "../../Services/Translation/TranslationService";
import { useLanguage } from "../LanguageSelector";
import "./Style.css";

const AutoTranslate = ({ children, targetLanguage = null, sourceLanguage = "ko", fallback = null, className = "", tag = "span", showLoading = true, asText = false, ...props }) => {
  const { currentLanguage } = useLanguage();
  const [translatedText, setTranslatedText] = useState("");
  const [isTranslating, setIsTranslating] = useState(false);
  const [hasError, setHasError] = useState(false);

  // 번역할 텍스트 결정
  // const textToTranslate = typeof children === "string" ? children : "";
  const textToTranslate = React.Children.toArray(children).join("");

  // 실제 타겟 언어 결정 (props로 전달받은 언어가 없으면 전역 언어 사용)
  const actualTargetLanguage = targetLanguage || currentLanguage;

  useEffect(() => {
    const translateText = async () => {
      if (!textToTranslate || !textToTranslate.trim()) {
        setTranslatedText(textToTranslate);
        return;
      }

      // 소스 언어와 타겟 언어가 같으면 번역하지 않음
      if (sourceLanguage === actualTargetLanguage) {
        setTranslatedText(textToTranslate);
        return;
      }

      setIsTranslating(true);
      setHasError(false);

      try {
        const result = await TranslationService.translateText(textToTranslate, actualTargetLanguage, sourceLanguage);
        setTranslatedText(result);
      } catch (error) {
        console.error("AutoTranslate error:", error);
        setHasError(true);
        setTranslatedText(textToTranslate); // 에러 시 원본 텍스트 사용
      } finally {
        setIsTranslating(false);
      }
    };

    translateText();
  }, [textToTranslate, actualTargetLanguage, sourceLanguage]);

  // 태그에 따라 다른 요소 렌더링
  const Tag = tag;

  // asText가 true인 경우 단순 텍스트만 반환 (option 내부에서 사용)
  if (asText) {
    if (hasError && fallback) {
      return fallback;
    }
    if (isTranslating && showLoading) {
      return textToTranslate + "...";
    }
    return translatedText || textToTranslate;
  }

  // 에러가 있고 fallback이 있는 경우
  if (hasError && fallback) {
    return (
      <Tag className={className} {...props}>
        {fallback}
      </Tag>
    );
  }

  // 번역 중일 때 로딩 표시
  if (isTranslating && showLoading) {
    return (
      <Tag className={`auto-translate-loading ${className}`} {...props}>
        {textToTranslate}
        <span className='translate-indicator'>...</span>
      </Tag>
    );
  }

  return (
    <Tag className={className} {...props}>
      {translatedText || textToTranslate}
    </Tag>
  );
};

export default AutoTranslate;
